export default __webpack_public_path__ + "static/media/NFD_Minting_Guide1024_12.2eecc2a2.png";